import PodcastPlayerSpotify from "./podcast-player-spotify";


export default function PodcastPlayer3() {
  return (
    <div className="container">
      <h1>Episode 0: When Smart Money Makes Dumb Mistakes</h1>
      <PodcastPlayerSpotify
        episodeId="3Tkuk23ue9qZrhpbWATdU5"
        start={0}
        compactOnMobile={true}
      />
    </div>
  );
}
{/* <div id="buzzsprout-player-17681767"></div><script src="https://www.buzzsprout.com/2529265/episodes/17681767-bridge-to-bharath-when-smart-money-makes-dumb-mistakes-in-india.js?container_id=buzzsprout-player-17681767&player=small" type="text/javascript" charset="utf-8"></script> */}